import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=35e7d2d6&scoped=true"
import script from "./detail-content.vue?vue&type=script&lang=js"
export * from "./detail-content.vue?vue&type=script&lang=js"
import style0 from "./detail-content.vue?vue&type=style&index=0&id=35e7d2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e7d2d6",
  null
  
)

export default component.exports